<template>
  <div class="session-card">
    <div>
      <div v-if="session._booked_at" class="time-day">
        <h4 class="day">
          {{
            session._booked_at
              .toDate()
              .toDateString("d MMM, hh:mm a")
              .substring(0, 3)
          }}
        </h4>
        <h4 class="date">
          {{
            session._booked_at
              .toDate()
              .toDateString("d MMM, hh:mm a")
              .substring(8, 10)
          }}
        </h4>
        <h4 class="month">
          {{
            session._booked_at
              .toDate()
              .toDateString("d MMM, hh:mm a")
              .substring(4, 7)
          }}
        </h4>
      </div>
    </div>
    <div>
      <h3 v-if="session.plan.title" class="title">{{ session.plan.title }}</h3>
      <p v-if="session.plan.summary" class="desc">
        {{ `${session.plan.summary.substr(0, 100)}...` }}
      </p>
      <div class="profile">
        <div class="user-img">
          <img
            v-if="session.user.imgURL"
            :src="session.user.imgURL"
            alt="img"
          />
        </div>
        <div class="info">
          <div class="d-flex justify-content-between align-items-center">
            <h4 v-if="session.user" class="user-name">
              {{ `${session.user.firstname} ${session.user.lastname}` }}
            </h4>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.1887 6.01718L10.2215 5.44062L8.4481 1.84531C8.39966 1.74687 8.31998 1.66718 8.22154 1.61875C7.97466 1.49687 7.67466 1.59843 7.55123 1.84531L5.77779 5.44062L1.8106 6.01718C1.70123 6.03281 1.60123 6.08437 1.52466 6.1625C1.4321 6.25763 1.3811 6.38562 1.38286 6.51834C1.38461 6.65106 1.43899 6.77766 1.53404 6.87031L4.40435 9.66875L3.72623 13.6203C3.71032 13.7122 3.7205 13.8068 3.75559 13.8932C3.79068 13.9796 3.84929 14.0545 3.92477 14.1093C4.00025 14.1642 4.08958 14.1967 4.18263 14.2034C4.27568 14.21 4.36873 14.1904 4.45123 14.1469L7.99966 12.2812L11.5481 14.1469C11.645 14.1984 11.7575 14.2156 11.8653 14.1969C12.1372 14.15 12.32 13.8922 12.2731 13.6203L11.595 9.66875L14.4653 6.87031C14.5434 6.79375 14.595 6.69375 14.6106 6.58437C14.6528 6.31093 14.4622 6.05781 14.1887 6.01718Z"
                fill="#EABA26"
              />
            </svg>
            <span>4.5</span>
            <span v-if="session.plan.price" class="ml-2"
              >${{ session.plan.price }}</span
            >
          </div>
          <h5 class="speciality">Build Technology</h5>
        </div>
      </div>
    </div>
    <div>
      <div
        class="d-flex justify-content-end align-items-center"
        style="height: 100%"
      >
        <button class="btn start-session" @click="startSession(session)">
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.5 13.5H2C1.73478 13.5 1.48043 13.3946 1.29289 13.2071C1.10536 13.0196 1 12.7652 1 12.5V4.5C1 4.23478 1.10536 3.98043 1.29289 3.79289C1.48043 3.60536 1.73478 3.5 2 3.5H10.5C10.7652 3.5 11.0196 3.60536 11.2071 3.79289C11.3946 3.98043 11.5 4.23478 11.5 4.5V6.53L14.21 4.595C14.2846 4.54187 14.3724 4.51025 14.4638 4.50362C14.5552 4.49698 14.6466 4.51557 14.7281 4.55737C14.8096 4.59916 14.8781 4.66254 14.926 4.7406C14.974 4.81866 14.9996 4.90839 15 5V12C14.9996 12.0916 14.974 12.1813 14.926 12.2594C14.8781 12.3375 14.8096 12.4008 14.7281 12.4426C14.6466 12.4844 14.5552 12.503 14.4638 12.4964C14.3724 12.4897 14.2846 12.4581 14.21 12.405L11.5 10.47V12.5C11.5 12.7652 11.3946 13.0196 11.2071 13.2071C11.0196 13.3946 10.7652 13.5 10.5 13.5Z"
              fill="var(--theme-color)"
            />
          </svg>
          Start
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SessionCard",
  props: {
    session: {
      type: Object,
      required: true
    }
  },
  methods: {
    startSession(session) {
      this.$emit("handleSessionClick", session);
    }
  }
};
</script>

<style lang="scss" scoped>
.session-card {
  background-color: #fff;
  /*min-width: 504px;*/
  width: 100%;
  height: 137px;
  border-radius: 8px;
  padding: 16px;
  display: grid;
  grid-template-columns: 60px 1fr 96px;
  margin-bottom: 16px;
  .time-day {
    margin-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .day,
    .date,
    .month {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      color: #474d52;
      margin: 0;
    }
    .date {
      font-weight: bold;
      font-size: 40px;
      line-height: 55px;
    }
    .month {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
    }
  }
  .title,
  .desc {
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #474d52;
  }
  .desc {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
  }
  .profile {
    display: flex;
    justify-content: flex-start;
    .user-img {
      padding-right: 10px;
      cursor: pointer;
      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
    .user-name {
      margin-right: 20px;
      cursor: pointer;
    }
    .user-name,
    .speciality,
    .info span {
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
      margin-bottom: 0;
    }
    .info span {
      font-size: 12px;
    }
    .speciality {
      font-size: 12px;
      color: #8d99a0;
    }
  }
  .start-session {
    /*width: 99px;*/
    height: 35px;
    background: #f3f6f9;
    border-radius: 4px;
    font-family: "Nunito", sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    color: var(--theme-color);
    margin-left: 4px;
    text-transform: uppercase;
    svg {
      margin-right: 10px;
    }
    &:hover {
      background: rgb(229, 237, 245);
    }
  }
}

@media (max-width: 786px) {
  .session-card {
    grid-template-columns: 100px 1fr;
    height: unset;
  }
}
@media (max-width: 504px) {
  .session-card {
    grid-template-columns: 1fr;
    height: unset;
    .time-day {
      flex-direction: row;
      justify-content: space-between;
    }
  }
}
</style>
